/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbrirChamadoDto,
  AnexoDeChamadoResponse,
  ChamadoResponse,
  ChamadosControllerEnviarAnexoBody,
  ChamadosControllerListarMensagensParams,
  ChamadosControllerListarParams,
  EnviarMensagemChamadoDto,
  ErroResponse,
  MensagemChamadoResponse,
  PaginaDeChamadosResponse,
  PaginaDeMensagensDeChamadoResponse,
  ResumoDeSuporteResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getChamadosControllerResumoUrl = () => {




  return `/v1/chamados/resumo`
}

/**
 * @summary Contadores dos meus chamados — alimenta o badge do botão de suporte
 */
export const chamadosControllerResumo = async ( options?: Parameters<typeof httpClient>[1]): Promise<ResumoDeSuporteResponse> => {

  return httpClient<ResumoDeSuporteResponse>(getChamadosControllerResumoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosControllerResumoQueryKey = () => {
    return [
    `/v1/chamados/resumo`
    ] as const;
    }


export const getChamadosControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof chamadosControllerResumo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosControllerResumoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosControllerResumo>>> = ({ signal }) => chamadosControllerResumo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerResumo>>>
export type ChamadosControllerResumoQueryError = unknown


export function useChamadosControllerResumo<TData = Awaited<ReturnType<typeof chamadosControllerResumo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerResumo<TData = Awaited<ReturnType<typeof chamadosControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerResumo<TData = Awaited<ReturnType<typeof chamadosControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Contadores dos meus chamados — alimenta o badge do botão de suporte
 */

export function useChamadosControllerResumo<TData = Awaited<ReturnType<typeof chamadosControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosControllerResumoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosControllerEnviarAnexoUrl = () => {




  return `/v1/chamados/anexos`
}

/**
 * @summary Envia um anexo (print de tela, PDF) para usar depois numa mensagem
 */
export const chamadosControllerEnviarAnexo = async (chamadosControllerEnviarAnexoBody: ChamadosControllerEnviarAnexoBody, options?: Parameters<typeof httpClient>[1]): Promise<AnexoDeChamadoResponse> => {
    const formData = new FormData();
if(chamadosControllerEnviarAnexoBody.arquivo !== undefined) {
 formData.append(`arquivo`, chamadosControllerEnviarAnexoBody.arquivo);
 }

  return httpClient<AnexoDeChamadoResponse>(getChamadosControllerEnviarAnexoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getChamadosControllerEnviarAnexoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>, TError,{data: ChamadosControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>, TError,{data: ChamadosControllerEnviarAnexoBody}, TContext> => {

const mutationKey = ['chamadosControllerEnviarAnexo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>, {data: ChamadosControllerEnviarAnexoBody}> = (props) => {
          const {data} = props ?? {};

          return  chamadosControllerEnviarAnexo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosControllerEnviarAnexoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>>
    export type ChamadosControllerEnviarAnexoMutationBody = ChamadosControllerEnviarAnexoBody
    export type ChamadosControllerEnviarAnexoMutationError = unknown

    /**
 * @summary Envia um anexo (print de tela, PDF) para usar depois numa mensagem
 */
export const useChamadosControllerEnviarAnexo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>, TError,{data: ChamadosControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosControllerEnviarAnexo>>,
        TError,
        {data: ChamadosControllerEnviarAnexoBody},
        TContext
      > => {
      return useMutation(getChamadosControllerEnviarAnexoMutationOptions(options), queryClient);
    }
    export const getChamadosControllerAbrirUrl = () => {




  return `/v1/chamados`
}

/**
 * @summary Abre um chamado de suporte
 */
export const chamadosControllerAbrir = async (abrirChamadoDto: AbrirChamadoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoResponse> => {

  return httpClient<ChamadoResponse>(getChamadosControllerAbrirUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(abrirChamadoDto)
  }
);}





export const getChamadosControllerAbrirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerAbrir>>, TError,{data: AbrirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerAbrir>>, TError,{data: AbrirChamadoDto}, TContext> => {

const mutationKey = ['chamadosControllerAbrir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosControllerAbrir>>, {data: AbrirChamadoDto}> = (props) => {
          const {data} = props ?? {};

          return  chamadosControllerAbrir(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosControllerAbrirMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerAbrir>>>
    export type ChamadosControllerAbrirMutationBody = AbrirChamadoDto
    export type ChamadosControllerAbrirMutationError = unknown

    /**
 * @summary Abre um chamado de suporte
 */
export const useChamadosControllerAbrir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerAbrir>>, TError,{data: AbrirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosControllerAbrir>>,
        TError,
        {data: AbrirChamadoDto},
        TContext
      > => {
      return useMutation(getChamadosControllerAbrirMutationOptions(options), queryClient);
    }
    export const getChamadosControllerListarUrl = (params?: ChamadosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/chamados?${stringifiedParams}` : `/v1/chamados`
}

/**
 * @summary Chamados do meu ambiente
 */
export const chamadosControllerListar = async (params?: ChamadosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeChamadosResponse> => {

  return httpClient<PaginaDeChamadosResponse>(getChamadosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosControllerListarQueryKey = (params?: ChamadosControllerListarParams,) => {
    return [
    `/v1/chamados`, ...(params ? [params] : [])
    ] as const;
    }


export const getChamadosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof chamadosControllerListar>>, TError = unknown>(params?: ChamadosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosControllerListar>>> = ({ signal }) => chamadosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerListar>>>
export type ChamadosControllerListarQueryError = unknown


export function useChamadosControllerListar<TData = Awaited<ReturnType<typeof chamadosControllerListar>>, TError = unknown>(
 params: undefined |  ChamadosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerListar<TData = Awaited<ReturnType<typeof chamadosControllerListar>>, TError = unknown>(
 params?: ChamadosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerListar<TData = Awaited<ReturnType<typeof chamadosControllerListar>>, TError = unknown>(
 params?: ChamadosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Chamados do meu ambiente
 */

export function useChamadosControllerListar<TData = Awaited<ReturnType<typeof chamadosControllerListar>>, TError = unknown>(
 params?: ChamadosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosControllerDetalharUrl = (id: string,) => {




  return `/v1/chamados/${id}`
}

/**
 * @summary Detalhe de um chamado
 */
export const chamadosControllerDetalhar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoResponse> => {

  return httpClient<ChamadoResponse>(getChamadosControllerDetalharUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosControllerDetalharQueryKey = (id: string,) => {
    return [
    `/v1/chamados/${id}`
    ] as const;
    }


export const getChamadosControllerDetalharQueryOptions = <TData = Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosControllerDetalharQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosControllerDetalhar>>> = ({ signal }) => chamadosControllerDetalhar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosControllerDetalharQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerDetalhar>>>
export type ChamadosControllerDetalharQueryError = ErroResponse


export function useChamadosControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalhe de um chamado
 */

export function useChamadosControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosControllerDetalharQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosControllerListarMensagensUrl = (id: string,
    params?: ChamadosControllerListarMensagensParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/chamados/${id}/mensagens?${stringifiedParams}` : `/v1/chamados/${id}/mensagens`
}

/**
 * @summary Conversa do chamado
 */
export const chamadosControllerListarMensagens = async (id: string,
    params?: ChamadosControllerListarMensagensParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeMensagensDeChamadoResponse> => {

  return httpClient<PaginaDeMensagensDeChamadoResponse>(getChamadosControllerListarMensagensUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosControllerListarMensagensQueryKey = (id: string,
    params?: ChamadosControllerListarMensagensParams,) => {
    return [
    `/v1/chamados/${id}/mensagens`, ...(params ? [params] : [])
    ] as const;
    }


export const getChamadosControllerListarMensagensQueryOptions = <TData = Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError = unknown>(id: string,
    params?: ChamadosControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosControllerListarMensagensQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>> = ({ signal }) => chamadosControllerListarMensagens(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosControllerListarMensagensQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>>
export type ChamadosControllerListarMensagensQueryError = unknown


export function useChamadosControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError = unknown>(
 id: string,
    params: undefined |  ChamadosControllerListarMensagensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof chamadosControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Conversa do chamado
 */

export function useChamadosControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosControllerListarMensagensQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosControllerEnviarMensagemUrl = (id: string,) => {




  return `/v1/chamados/${id}/mensagens`
}

/**
 * @summary Envia uma mensagem no chamado
 */
export const chamadosControllerEnviarMensagem = async (id: string,
    enviarMensagemChamadoDto: EnviarMensagemChamadoDto, options?: Parameters<typeof httpClient>[1]): Promise<MensagemChamadoResponse> => {

  return httpClient<MensagemChamadoResponse>(getChamadosControllerEnviarMensagemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enviarMensagemChamadoDto)
  }
);}





export const getChamadosControllerEnviarMensagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoDto}, TContext> => {

const mutationKey = ['chamadosControllerEnviarMensagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>, {id: string;data: EnviarMensagemChamadoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosControllerEnviarMensagem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosControllerEnviarMensagemMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>>
    export type ChamadosControllerEnviarMensagemMutationBody = EnviarMensagemChamadoDto
    export type ChamadosControllerEnviarMensagemMutationError = ErroResponse

    /**
 * @summary Envia uma mensagem no chamado
 */
export const useChamadosControllerEnviarMensagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosControllerEnviarMensagem>>,
        TError,
        {id: string;data: EnviarMensagemChamadoDto},
        TContext
      > => {
      return useMutation(getChamadosControllerEnviarMensagemMutationOptions(options), queryClient);
    }
    export const getChamadosControllerMarcarComoLidoUrl = (id: string,) => {




  return `/v1/chamados/${id}/leitura`
}

/**
 * @summary Marca o chamado como lido até agora
 */
export const chamadosControllerMarcarComoLido = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getChamadosControllerMarcarComoLidoUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getChamadosControllerMarcarComoLidoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>, TError,{id: string}, TContext> => {

const mutationKey = ['chamadosControllerMarcarComoLido'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  chamadosControllerMarcarComoLido(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosControllerMarcarComoLidoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>>

    export type ChamadosControllerMarcarComoLidoMutationError = unknown

    /**
 * @summary Marca o chamado como lido até agora
 */
export const useChamadosControllerMarcarComoLido = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosControllerMarcarComoLido>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getChamadosControllerMarcarComoLidoMutationOptions(options), queryClient);
    }
    export const getChamadosControllerCancelarUrl = (id: string,) => {




  return `/v1/chamados/${id}/cancelar`
}

/**
 * @summary Cancela o chamado — só quem abriu, e só enquanto ninguém o assumiu
 */
export const chamadosControllerCancelar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoResponse> => {

  return httpClient<ChamadoResponse>(getChamadosControllerCancelarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getChamadosControllerCancelarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerCancelar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerCancelar>>, TError,{id: string}, TContext> => {

const mutationKey = ['chamadosControllerCancelar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosControllerCancelar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  chamadosControllerCancelar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosControllerCancelarMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosControllerCancelar>>>

    export type ChamadosControllerCancelarMutationError = ErroResponse

    /**
 * @summary Cancela o chamado — só quem abriu, e só enquanto ninguém o assumiu
 */
export const useChamadosControllerCancelar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosControllerCancelar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosControllerCancelar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getChamadosControllerCancelarMutationOptions(options), queryClient);
    }
